import { apiStoreLenses } from 'root/src/client/logic/api/lenses'
import currentRouteParamsRecordId from 'root/src/client/logic/route/selectors/currentRouteParamsRecordId'

const { viewCreatorDataChild } = apiStoreLenses

export default (state) => {
	const recordId = currentRouteParamsRecordId(state)
	return viewCreatorDataChild(recordId, state)
}
